import { BorrowerOwnership } from 'prequalificationV2/api/HomeOwnershipsApi';
import { OwnershipLabel } from 'prequalificationV2/pages/Dashboard/steps/InformationTabs/HomeOwnershipTab/HomeOwnershipInfo/homeOwnershipInfo.enums';

export const MAP_OWNERSHIP_LABEL_TO_OWNERSHIP = {
  [OwnershipLabel.OwnWithMortgage]: BorrowerOwnership.Buying,
  [OwnershipLabel.OwnFreeClear]: BorrowerOwnership.Own,
  [OwnershipLabel.Rent]: BorrowerOwnership.Rent,
  [OwnershipLabel.LiveWithParents]: BorrowerOwnership.LiveWithParents,
};

export const MAP_OWNERSHIP_TO_OWNERSHIP_LABEL = {
  [BorrowerOwnership.Buying]: OwnershipLabel.OwnWithMortgage,
  [BorrowerOwnership.Own]: OwnershipLabel.OwnFreeClear,
  [BorrowerOwnership.Rent]: OwnershipLabel.Rent,
  [BorrowerOwnership.LiveWithParents]: OwnershipLabel.LiveWithParents,
};
